import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

@Component({
    selector: 'app-export-excel',
    templateUrl: './export-excel.component.html',
    styleUrls: ['./export-excel.component.scss'],
    standalone: false
})
export class ExportExcelComponent implements OnInit {
  @Output() exportFile = new EventEmitter<any>();
  @Input() title :string = 'Export to xlsx';
  @Input() height: number = 10;
  @Input() width: number = 10; 
  @Input() hoverColor: string='';
  @Input() cursor: string='';
  constructor() {}

  ngOnInit(): void {}

  fnDownloadExcel(){
    this.exportFile.emit();
  }
}
